const isMessageHasArabic = (msg) => {
  const arabicPattern = /[\u0600-\u06FF]/;
  return arabicPattern.test(msg);
};

const isLink = (message) => {
  let urlString;
  try {
    urlString = new URL(message);
  } catch (_) {
    return false;
  }
  return urlString.protocol === "http:" || urlString.protocol === "https:";
};

export { isMessageHasArabic, isLink };
